import React, { useEffect } from "react";
import OfferDataSection from "./OfferDataSection";
export default function Offers() {
  return (
    <>
      <OfferDataSection />
      {/* يمكن إضافة باقي أقسام الصفحة هنا */}
    </>
  );
}
